import React from "react";
import { Card, Col, Row, Select } from "antd";
import { LineChart } from ".";

const UsersChart = (props: any) => {
  const handleFilterChange = (value: string) => {
    props.onFilterChange(value);
    props.setName("right");
  };

  return (
    <div style={{ padding: 0 }}>
      <Card className="chart_card">
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <h2>Total Users</h2>
          <div style={{ width: "20%" }}>
            <Select
              style={{ width: "100%" }}
              defaultValue={"monthly"}
              onChange={handleFilterChange}
              placeholder="Filter"
              options={[
                { value: "daily", label: "Daily" },
                { value: "weekly", label: "Weekly" },
                { value: "monthly", label: "Monthly" },
                { value: "yearly", label: "Yearly" },
              ]}
            />
          </div>
        </div>
        <div style={{ margin: "auto" }}>
          <LineChart data={props.graphCustomerData} />
        </div>
      </Card>
    </div>
  );
};

export default UsersChart;
